var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster-setup-single container"},[_c('img',{staticStyle:{"width":"100%","display":"block","max-height":"500px"},attrs:{"src":_vm.singlePosterImg}})])}
var staticRenderFns = []

export { render, staticRenderFns }